import { Controller } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import { Buttons, Bid, ChooseCountriesBtn } from 'components';
import { CountryItem } from '../countryItem/CountryItem';
import { minServingFields } from 'constants';
import { ErrorIcon } from 'assets/icons';
import { limitDecimal, formatOnBlur } from 'utils';
import { validateCPI, validateeCPM } from '../../validation';
import * as S from '../../MinimumServingForm.styled';

const fieldName = minServingFields.network.field;

const NetworkCampaigns = ({
  defaultAppMinEcpiBidBudget,
  control,
  setValue,
  networkCampaignsCountries,
  handleClearCountries,
  saveButtonNetworkCampaigns,
  clearErrors,
  errors,
  handleDeleteCountry,
}) => {
  return (
    <>
      <S.Head>Minimum Serving for Network Campaigns</S.Head>
      <S.Field>
        <S.TextField>
          Set a minimum serving values (in $) for network campaigns.
          <br /> If a minimum bid was set, campaigns with a lower bid will not be served
        </S.TextField>
      </S.Field>
      <S.Field middle>
        <S.Title>Minimum Bid:</S.Title>
        <S.FieldsWrap>
          <Controller
            defaultValue={defaultAppMinEcpiBidBudget[0]?.minCpi}
            name={`${fieldName}.minCpi`}
            control={control}
            rules={validateCPI}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <S.InputWrap>
                <Bid.Big
                  label='CPI'
                  value={value}
                  error={!!error}
                  onChange={(e) => limitDecimal(e, onChange, 2)}
                  onBlur={() => formatOnBlur(value, onChange)}
                />
                {!!error && (
                  <S.ErrorWrap>
                    <ErrorIcon />
                    {error?.message}
                  </S.ErrorWrap>
                )}
              </S.InputWrap>
            )}
          />
          <Controller
            defaultValue={defaultAppMinEcpiBidBudget[0]?.minEcpm}
            name={`${fieldName}.minEcpm`}
            control={control}
            rules={validateeCPM}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <S.InputWrap>
                <Bid.Big
                  label='eCPM'
                  value={value}
                  error={!!error}
                  onChange={(e) => limitDecimal(e, onChange, 3)}
                  onBlur={() => formatOnBlur(value, onChange)}
                />
                {!!error && (
                  <S.ErrorWrap>
                    <ErrorIcon />
                    {error?.message}
                  </S.ErrorWrap>
                )}
              </S.InputWrap>
            )}
          />
        </S.FieldsWrap>
      </S.Field>
      <S.Field>
        <S.Title>Per Countries:</S.Title>
        <S.FieldsWrap>
          <S.ActionField>
            <ChooseCountriesBtn
              selectedCountries={networkCampaignsCountries}
              title='Included Countries'
              saveButtonAction={saveButtonNetworkCampaigns}
            />
            {networkCampaignsCountries?.length > 0 && (
              <>
                <Divider />
                <Buttons.TertiaryNormal
                  id='NetworkCampaignsClearAllBtn'
                  onClick={() => handleClearCountries(fieldName)}
                >
                  Clear All
                </Buttons.TertiaryNormal>
                {networkCampaignsCountries.map((country, ind) => (
                  <CountryItem
                    key={country.cca2}
                    country={country}
                    control={control}
                    index={ind}
                    setValue={setValue}
                    field={fieldName}
                    errors={errors}
                    clearErrors={clearErrors}
                    handleDeleteCountry={handleDeleteCountry}
                  />
                ))}
              </>
            )}
          </S.ActionField>
        </S.FieldsWrap>
      </S.Field>
    </>
  );
};

export default NetworkCampaigns;
